import React from "react";
import { Link } from "react-router-dom";

// Render the exhibition title. If a `link` with `theLink` is provided
// the title itself becomes a clickable internal link to the exhibition
// page; if `linkText` is also provided, fall back to the older pattern
// of rendering a separate "Go to Exhibition" link below the entry.
function renderTitle(exhibition, link) {
  if (link && link.theLink && !link.linkText) {
    return (
      <Link to={link.theLink} className='exTitleLink'>
        {exhibition}
      </Link>
    );
  }
  return exhibition;
}

function renderLink(link) {
  if (link) {
    if (link.theLink && link.linkText) {
      return (
        <Link to={link.theLink} className='exLink'>
          {link.linkText}
        </Link>
      );
    }
  }
}
function renderLinkOut(linkOut) {
  if (linkOut) {
    if (linkOut.theLink && linkOut.linkText) {
      return (
        <a
          className='exLink'
          target='_blank'
          rel='noreferrer'
          href={linkOut.theLink}
        >
          {linkOut.linkText}
        </a>
      );
    }
  }
}

function renderYear(year) {
  if (year) {
    return <h2>{year}</h2>;
  }
}

function Exhibition({ exhibition, location, year, date, link, linkOut, variant }) {
  if (variant === "timeline") {
    return (
      <div className='exTimelineEntry'>
        <div className='exTimelineTitle'>{renderTitle(exhibition, link)}</div>
        {location && <div className='exTimelineLocation'>{location}</div>}
        {date && <div className='exTimelineDate'>{date}</div>}
        {renderLinkOut(linkOut)}
        {renderLink(link)}
      </div>
    );
  }

  return (
    <div className='exhibitionBox'>
      {renderYear(year)}
      <div>{renderTitle(exhibition, link)}</div>
      <div>{location}</div>
      <div>{date}</div>
      {renderLinkOut(linkOut)}
      {renderLink(link)}
    </div>
  );
}

export default Exhibition;
